
<template>
  <div class="user" id="myuser">
    <div class="userlist-title">
      <div class="user-head">
        <div>
            <el-select v-model="warnInfo.elemapid" clearable filterable placeholder="请选择模拟图">
              <el-option
                v-for="item in elemapData"
                :key="item.id"
                :label="item.title"
                :value="item.elemapid">
                </el-option>
            </el-select>
          <el-date-picker
            v-model="warnInfo.datetime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div>
          <el-select v-model="warnInfo.userid" clearable filterable placeholder="请选择操作人">
              <el-option
              v-for="item in userData"
              :key="item.id"
              :label="item.name"
              :value="item.userid">
              </el-option>
          </el-select>
            <el-select v-model="warnInfo.status" clearable filterable placeholder="请选择状态">
              <el-option
              v-for="item in recordStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
              </el-option>
          </el-select>
        </div>
        <div>
          <el-button type="primary" size="medium" icon="el-icon-search" @click="getWarnInfo" style="margin-left:10px">查 询</el-button>
        </div>
      </div>

    </div>
    <div class="userlist-content" id="userlistContent">
      <el-table
        ref="myHeight"
        :data="tableData"
        tooltip-effect="dark"
        
        :max-height="clientHeight"
        >
        <el-table-column prop="title" label="模拟图标题"  align='center'></el-table-column>
        <el-table-column prop="warntime" label="时间"  align='center'></el-table-column>
        <el-table-column prop="normalstatus" label="标准状态"  align='center' width='150'></el-table-column>
        <el-table-column prop="abnormalstatus" label="异常状态"  align='center' width='150'></el-table-column>
        <el-table-column prop="status" label="状态"  align='center' width='150' :formatter='getStatus'></el-table-column>
        <el-table-column prop="name" label="操作人"  align='center'></el-table-column>
        
        <!-- <el-table-column label="操作"  align='center'>
          <template slot-scope="scope">
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >忽略</el-button>
            <el-button
              size="mini"
              icon="el-icon-warning-outline"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
            >提醒</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20,50,100]"
        :page-size="warnInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="maxCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
    data () {
      return {
          tableData:[],
          userData:[],
          elemapData:[],
          value1:"",
          clientHeight:null,
          warnInfo:{
            datetime:[],
            userid:'',
            elemapid:'',
            updatecontent:'',
            pageIndex:1,
            pageSize:10,
            status:1,
          },
          maxCount:0,
          normalstatus:[
            {name:"开",value:1},
            {name:"关",value:2},
          ],
          abnormalstatus:[
            {name:"开",value:1},
            {name:"关",value:2},
          ],
          dialogVisible:false,
          time:"",
          content:"",
          mapname:"",
          recordStatus:[
            {label:"异常",value:1},
            {label:"正常",value:2},
          ]
     }
   },
    computed:{
    },
    components:{
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      // clientHeight: function () {
      //   this.changeFixed(this.clientHeight)
      // },
    },
    mounted(){
      this.clientHeight =   `${document.documentElement.clientHeight}`-250         
      window.onresize = function temp() {
        this.clientHeight = `${document.documentElement.clientHeight}`-250 ;
      };
      this.getWarnInfo()
    },
    methods:{
      //格式化
      normal(val){
        return this.normalstatus[val.normalstatus-1].name
      },
      abnormal(val){
        return this.abnormalstatus[val.abnormalstatus-1].name
      },
      getStatus(val){
        return val.status==1 ? "异常" : "正常"
      },
      getWarnInfo(){
         let _this=this;
         if(_this.warnInfo.datetime==null){
            _this.warnInfo.begindate = "";
            _this.warnInfo.enddate = "";
          }else {
            if (_this.warnInfo.datetime[0]) {
              _this.warnInfo.begindate = new Date(
                _this.warnInfo.datetime[0]
              ).Format("yyyy-MM-dd hh:mm");
            }
            if (_this.warnInfo.datetime[1]) {
              _this.warnInfo.enddate = new Date(
                _this.warnInfo.datetime[1]
              ).Format("yyyy-MM-dd hh:mm");
            }
          }
         this.$api.getWarnInfo(this.warnInfo, res => {
          let _this = this;
          //console.log(res,'resres')
           _this.tableData = res.data;
          _this.maxCount = res.maxCount || 0;

          _this.elemapData = res.data.filter((x, index,self)=>{
            var arrids = []
            res.data.forEach((item,i) => {
              arrids.push(item.elemapid)
            })
            return arrids.indexOf(x.elemapid) === index
          })  
           _this.userData = res.data.filter((x, index,self)=>{
            var users = []
            res.data.forEach((item,i) => {
              users.push(item.userid)
            })
            return users.indexOf(x.userid) === index
          })  
        });
      },
      changeFixed(clientHeight){ //动态修改样式
        this.$refs.myHeight.style.height = clientHeight+'px';
      },
      handleSizeChange(val) {
        this.warnInfo.pageSize=val
        this.getWarnInfo()
      },
      handleCurrentChange(val) {
        this.warnInfo.pageIndex=val
        this.getWarnInfo()
      },
      //删除 忽略
      handleDelete(index,row) {
          let _this = this;
          let params = {
            id: row.id
          };
          _this.$confirm("确认删除?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              this.$api.deleteWarn(params, da => {
                _this.$message.success({
                  message: "删除成功!"
                });
                if (_this.tableData.length == 1) {
                  _this.warnInfo.pageIndex = _this.warnInfo.pageIndex - 1;
                }
                _this.getWarnInfo();
              });
            });
      },
      //提醒
      handleEdit(index,row){
        this.dialogVisible=true;
        this.content=row.updatecontent;
        this.mapname=row.title
        //console.log(row)
      },
      //确认提醒
      confirm(){
        var params={
          content:this.content,
          warntime:this.time,
          mapname:this.mapname
        }
        //console.log(params)
        this.$api.addInfo(params,res=>{
          //console.log(res)
          if(res.errCode==0){
            this.$message({
              type:'success',
              message:"新增提醒成功"
            })
            this.dialogVisible=false
          }else{
            this.$message.error("新增失败")
          }
        })
      }
    }
}

</script>
<style scoped>
.userlist-content{
  /* width: 100%; */
  overflow-x: auto;
  margin-top: 20px;
}
  .user{
    width: 80%;
    padding: 20px;
    margin: 0 auto;
  }
  .user-head{
    display: flex;   
    align-items: center;                         
    font-size: 14px;
    justify-content: start;
  }
  .user-head /deep/ .el-input__inner{
    width: 300px;
  }



  /* .user-head  /deep/ .el-button--mini{
    height: 30px;
    margin-top: 5px;
    margin-left: 20px;
  } */
.pagination{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.warntime{
  /* display: flex; */
}

</style>



// WEBPACK FOOTER //
// src/components/warn.vue